// extracted by mini-css-extract-plugin
export default {"root":"FlexRow_root__ihAz2","wrap":"FlexRow_wrap__-wPHU"};